import playerStore from '../store/players';

/**
 * Адрес профиля игрока: /players/<логин>, если у игрока есть аккаунт,
 * иначе /players/<id>. Логин берётся из загруженного списка игроков;
 * пока он не загружен — ссылка по id (страница игрока сама заменит адрес).
 */
export const playerPath = (id: string, login?: string | null) =>
    '/players/' + (login ?? playerStore.playersById.get(id)?.login ?? id);
